module.exports = "/assets/data/3f5c0768f3643749a524658108d02549-HU12.data.json";